import styled, { css } from 'styled-components'

import Link from '../../Link'

export const Container = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 992px) {
    align-items: flex-start;
  }
`

export const FooterCategory = styled.div`
  font-size: 1.1875rem;
  margin: 3rem 0 0.5rem 0;
  color: ${({ theme }) => theme.colors.coolGray.cool450};
  @media (min-width: 992px) {
    font-size: 0.9375rem;
    margin: 0 0 5px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.coolGray.cool500};
  }
`

export const Dropdown = styled.div`
  position: relative;
  display: flex;
`

export const DropdownToggle = styled.button<{ $isOpen: boolean }>`
  white-space: nowrap;
  border-radius: 0;
  background-color: transparent;
  border: 1px solid transparent;
  border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool700};
  padding: 14px 10px;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 0.9375rem;
  color: ${({ theme }) => theme.colors.grayscale.white};
  cursor: pointer;
  display: flex;
  align-items: center;
  font-weight: 500;
  letter-spacing: normal;
  text-transform: uppercase;
  transition:
    color 0.15s ease-in-out 0s,
    background-color 0.15s ease-in-out 0s,
    border-color 0.15s ease-in-out 0s,
    box-shadow 0.15s ease-in-out 0s;
  &:hover {
    background-color: transparent;
    border-color: transparent;
    border-bottom: 1px solid #4a4b4f;
  }
  &:focus {
    outline: 1px solid #fff !important;
    background-color: transparent;
    outline-offset: 5px !important;
    box-shadow: 0 0 0 0.2rem rgba(83, 84, 88, 0.5);
  }
  &:after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: '';
    transition: transform 0.3s;
    ${({ $isOpen }) =>
      $isOpen &&
      css`
        transform: rotate(-180deg);
      `};
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
  @media (min-width: 992px) {
    font-size: 14px;
    letter-spacing: 0.1em;
  }
`

export interface DropdownMenuProps {
  visible: boolean
}

export const DropdownMenu = styled.ul<DropdownMenuProps>`
  width: 240px;
  font-size: 14px;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  color: ${({ theme }) => theme.colors.coolGray.cool900};
  text-align: left;
  list-style: none;
  background-clip: padding-box;
  box-sizing: border-box;
`

export const DropdownItem = styled(Link)`
  padding: 16px 10px;
  border: 0;
  border-bottom: 1px solid #4a4b4f;
  background-color: #02162f;
  transition: all 0.35s;
  font-weight: 400;
  text-decoration: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  width: 100%;
  clear: both;
  text-align: inherit;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grayscale.white};
    color: ${({ theme }) => theme.colors.component.textDark} !important;
  }
  &:focus {
    background-color: #02162f;
  }
`

export const Title = styled.span`
  flex: 1;
  text-transform: uppercase;
  margin: 0 10px;
`
